const getProduct = (value) => {
  const search = `['OR', [
      ('template.name', 'ilike', '%${value}%'),
      ('template.salable', '=', True),
    ], [
      ('code', 'ilike', '${value}%'),
      ('template.salable', '=', True),
    ],]`;
  return search;
};

function layout() {
  const ctxView = {
    model: "sale.line",

    form_action: ["create"],
    table_action: ["update"],
    activeSearch: false,
    limit: 50,

    fields: {
      product: {
        type: "many2one",
        model: "product.product",
        recSearch: getProduct,
        // withChange: onChangeProduct,
        attrs: ["id", "list_price", "name"],
        required: true,
      },
      additionals: {
        type: "many2one",
        model: "sale.line",
        // attrs: ["id", "name"],
      },
      parent: {
        type: "many2one",
        model: "sale.line",
        // attrs: ["id", "name"],
        required: true,
      },
      quantity: {
        type: "integer",
        // withChange: onChangeQty,
        required: true,
      },

      // unit_price: {
      //   type: "numeric",
      //   readOnly: true,
      // },

      // unit_price_w_tax: {
      //   type: "numeric",
      //   readOnly: true,
      // },

      // discount: {
      //   type: "float",
      // },

      amount: {
        type: "numeric",
        // readOnly: true,
      },
      note: {
        type: "text",
      },
    },

    list: [
      { name: "product" },
      { name: "quantity" },
      { name: "note" },
      { name: "additionals" },
      { name: "parent" },
    ],

    form: [{ name: "product" }, { name: "quantity" }],
  };

  return ctxView;
}

export { layout };
